import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  ul: {
    display: 'flex',
    alignItems: 'center',
    margin: 0,
    padding: 0,
    listStyle: 'none',
  },
  btnPage: {
    minWidth: 'auto',
    width: 32,
    height: 32,
    margin: '0 3px',
    padding: '0 6px',
    fontSize: 15,
    fontFamily: 'NeoSansStd',
    background: 'transparent',
    borderRadius: 4,
    color: theme.custom.darkBlue,
    '&.Mui-disabled': {
      opacity: 0.26,
    },
  },
  selectedBtn: {
    background: 'rgba(0, 0, 0, 0.08)',
  },
  icon: {
    fontSize: '1.3rem',
    color: theme.custom.darkBlue,
  },
}));
